// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Loading_mainContainer__1Fhi9","rotating":"Loading_rotating__1aBAJ","infiniteRotation":"Loading_infiniteRotation__ke3iC"};